<template>
  <v-card
    class="dialog-card"
    style="padding-bottom: 25px">
    <ModalHeader
      helpFileName="SelectTag"
      icon="mdi-swap-horizontal"
      :modalTitle="'Select Icon'"
      @close="emit('close')" />
    <div
      style="
        height: 400px;
        width: 100%;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
      "
      class="pa-3">
      <div
        v-for="(icon, i) in icons"
        :key="i">
        <div
          class="mx-3 mb-3"
          style="cursor: pointer"
          @click="
            emit('select', 'mdi-' + icon);
            emit('close');
          ">
          <v-icon large>mdi-{{ icon }}</v-icon>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script setup>
const emit = defineEmits(['close', 'select']);
import ModalHeader from '../Shared/Modals/ModalHeader.vue';

const icons = [
  'cube-outline',
  'image-area',
  'movie-open',
  'video-wireless',
  'video-input-hdmi',
  'video-input-component',
  'abacus',
  'account-alert',
  'account-cancel',
  'account-arrow-left',
  'account-arrow-right',
  'account-clock',
  'account-search',
  'advertisements',
  'advertisements-off',
  'air-horn',
  'account-tie-voice',
  'airplane',
  'airplane-landing',
  'airplane-takeoff',
  'alarm',
  'alarm-light',
  'alarm-panel',
  'alien',
  'alpha-a-box',
  'alpha-b-box',
  'alpha-c-box',
  'alpha-d-box',
  'alpha-e-box',
  'alpha-f-box',
  'alpha-g-box',
  'alpha-h-box',
  'alpha-i-box',
  'alpha-j-box',
  'alpha-k-box',
  'alpha-l-box',
  'alpha-m-box',
  'alpha-n-box',
  'alpha-o-box',
  'alpha-p-box',
  'alpha-q-box',
  'alpha-r-box',
  'alpha-s-box',
  'alpha-t-box',
  'alpha-u-box',
  'alpha-v-box',
  'alpha-w-box',
  'alpha-x-box',
  'alpha-y-box',
  'alpha-z-box',
  'ambulance',
  'android',
  'application-brackets',
  'arm-flex',
  'arrow-down-box',
  'arrow-up-box',
  'arrow-left-box',
  'arrow-right-box',
  'arrow-u-down-left-bold',
  'arrow-u-down-right-bold',
  'arrow-u-up-right-bold',
  'arrow-u-up-left-bold',
  'atm',
  'atom',
  'asterisk',
  'assistant',
  'atom-variant',
  'augmented-reality',
  'badminton',
  'baguette',
  'bag-suitcase-outline',
  'bag-suitcase-off-outline',
  'bank',
  'balloon',
  'basketball-hoop-outline',
  'barcode',
  'barcode-scan',
  'barley',
  'barley-off',
  'bathtub-outline',
  'basketball',
  'baseball-bat',
  'barn',
  'beaker',
  'beach',
  'bed-outline',
  'bell',
  'beer-outline',
  'beehive-outline',
  'billiards',
  'bike',
  'blinds-open',
  'bitcoin',
  'boombox',
  'bowling',
  'briefcase-clock',
  'brightness-1',
  'brightness-2',
  'brightness-3',
  'brightness-4',
  'brightness-5',
  'brightness-6',
  'brightness-7',
  'broom',
  'brush-variant',
  'bullhorn',
  'bulldozer',
  'bus-stop',
  'cake',
  'camera',
  'camcorder',
  'camcorder-off',
  'candycane',
  'cannabis',
  'car-electric',
  'car',
  'car-speed-limiter',
  'cards-playing-spade',
  'cast-connected',
  'cash',
  'chart-areaspline',
  'chart-bar-stacked',
  'chart-gantt',
  'checkerboard',
  'comment-processing',
  'compass',
  'contactless-payment-circle',
  'comment-quote',
  'comment-question',
  'creation',
  'cursor-default-click-outline',
  'dice-5',
  'dev-to',
  'dolphin',
  'emoticon',
  'flower',
  'folder-network',
  'fruit-grapes',
  'soccer',
  'soccer-field',
  'cricket',
  'hamburger',
  'hand-back-left',
  'hanger',
  'hail',
  'halloween',
  'horse',
  'kayaking',
  'lightbulb-on-outline',
  'lightbulb-off-outline',
  'medal',
  'map-marker-star',
  'map-marker-alert',
  'map-marker',
  'map-legend',
  'mailbox',
  'numeric-1-box',
  'numeric-2-box',
  'numeric-3-box',
  'numeric-4-box',
  'numeric-5-box',
  'numeric-6-box',
  'numeric-7-box',
  'numeric-8-box',
  'numeric-9-box',
  'pac-man',
  'paperclip',
  'party-popper',
  'paw',
  'paw-off',
  'phone-in-talk',
  'piano',
  'projector-screen',
  'rugby',
  'satellite-variant',
  'snowboard',
  'toilet',
  'tools',
  'traffic-light',
  'unreal',
  'waves',
  'wrench-outline',
  'controller',
  'account-hard-hat',
];
</script>
